export class SearchHelpers {
  static getBirthYearString(birthYear: string, age: string, operator: string): string {
    const yearPrefix = operator === "lt" ? "<" : operator === "gte" ? ">" : "";
    return birthYear || age ? yearPrefix + (birthYear ? birthYear : age) : "";
  }

  static getSigExpressionString(sigId: string, operator: string, rating: string): string {
    return sigId + operator + rating;
  }
}
